import { RigidBodyType } from "~/types/RigidBodyType";

export const getDefaultMass = (bodyType: RigidBodyType) => {
  return bodyType === "dynamic" || "kinematic" ? 1 : 0;
};
